import React from 'react';
import BiCalculator from './CalculatorIcon';

export default function IntroPage({ onNextPage }) {
  return (
    <div className="draught-wastage">







      <div className="draught-wastage__page draught-wastage__intro">


        <div class="draught-wastage__text-holder">
          <p class="draught-wastage__headline">Did you know that poor dispense could be costing you <span>£1000s?</span>
          </p>
          <p class="draught-wastage__small-text">Use our handy online calculator to work out how much you could save per year with good dispense</p>
          <button onClick={() => { onNextPage(); }}>
            Calculate &gt;
          </button>
        </div>



      </div>
    </div>
  );
}
